"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.START_ZOOM_LEVEL = exports.MIN_ZOOM_LEVEL = exports.MAX_ZOOM_LEVEL = void 0;
exports.imageZoomBinding = imageZoomBinding;
exports.MAX_ZOOM_LEVEL = 14;
exports.MIN_ZOOM_LEVEL = 1;
exports.START_ZOOM_LEVEL = 1;
function imageZoomBinding(dc, evt) {
    const startZoom = dc.state.zoom || exports.START_ZOOM_LEVEL;
    const delta = evt.delta;
    let currentZoom = startZoom * delta;
    if (currentZoom < exports.MIN_ZOOM_LEVEL) {
        currentZoom = exports.MIN_ZOOM_LEVEL;
    }
    else if (currentZoom > exports.MAX_ZOOM_LEVEL) {
        currentZoom = exports.MAX_ZOOM_LEVEL;
    }
    currentZoom = Math.round(currentZoom * 100) / 100;
    if (currentZoom === startZoom) {
        return;
    }
    const mousePoint = evt.center;
    if (mousePoint != null) {
        const currentX = dc.state.centerX;
        const currentY = dc.state.centerY;
        const diffX = mousePoint.x - dc.state.centerX;
        const nextX = diffX * delta;
        const diffY = mousePoint.y - dc.state.centerY;
        const nextY = diffY * delta;
        dc.state.setZoom(currentZoom, currentX + nextX - diffX, currentY + nextY - diffY);
    }
    else {
        dc.state.setZoom(currentZoom);
    }
    if (evt.$event != null) {
        evt.$event.preventDefault();
    }
}
//# sourceMappingURL=image.zoom.binding.js.map